module.exports = __webpack_public_path__ + "img/Ellipse 4.d7eabe45.png";